// The picture of an area model: a rectangle split into rows and columns,
// with the side numbers along the top and down the left. Plain React SVG,
// like practice-graphs.tsx. The total is never printed.

import {
  AREA_MODEL_LABEL_SIZE,
  areaModelPicture,
  describeAreaModel,
  type AreaModelSpec,
} from './practice-area-model-data';

const INK = '#2d4a3e';
const PART_FILL = '#eef3ee';

export function AreaModelView({ model }: { model: AreaModelSpec }) {
  const picture = areaModelPicture(model);
  const right = picture.width - 6;
  const bottom = picture.height - 6;

  return (
    <figure className="m-0 max-w-md">
      <svg
        role="img"
        aria-label={describeAreaModel(model)}
        viewBox={`0 0 ${picture.width.toFixed(2)} ${picture.height.toFixed(2)}`}
        className="mx-auto block h-auto w-full"
        style={{ maxWidth: `${String(Math.round(picture.width * 1.3))}px` }}
      >
        <rect
          data-outline="true"
          x={picture.left}
          y={picture.top}
          width={right - picture.left}
          height={bottom - picture.top}
          fill={PART_FILL}
          stroke={INK}
          strokeWidth="2.2"
          strokeLinejoin="round"
        />
        {picture.columns.slice(1).map((column) => (
          <line
            key={column.x}
            data-split="column"
            x1={column.x}
            y1={picture.top}
            x2={column.x}
            y2={bottom}
            stroke={INK}
            strokeWidth="1.5"
          />
        ))}
        {picture.rows.slice(1).map((row) => (
          <line
            key={row.y}
            data-split="row"
            x1={picture.left}
            y1={row.y}
            x2={right}
            y2={row.y}
            stroke={INK}
            strokeWidth="1.5"
          />
        ))}
        {picture.columns.map((column) => (
          <text
            key={column.x}
            data-side="column"
            x={column.x + column.width / 2}
            y={picture.top - 8}
            textAnchor="middle"
            fill={INK}
            fontSize={AREA_MODEL_LABEL_SIZE}
            fontWeight="700"
          >
            {column.label}
          </text>
        ))}
        {picture.rows.map((row) => (
          <text
            key={row.y}
            data-side="row"
            x={picture.left - 8}
            y={row.y + row.height / 2}
            dy="0.35em"
            textAnchor="end"
            fill={INK}
            fontSize={AREA_MODEL_LABEL_SIZE}
            fontWeight="700"
          >
            {row.label}
          </text>
        ))}
        {picture.products.map((product, index) => (
          <text
            key={index}
            data-product="true"
            x={product.x}
            y={product.y}
            dy="0.35em"
            textAnchor="middle"
            fill={INK}
            fontSize={AREA_MODEL_LABEL_SIZE}
          >
            {product.text}
          </text>
        ))}
      </svg>
    </figure>
  );
}
